import { render, staticRenderFns } from "./ManufacturerSearch.vue?vue&type=template&id=552abeb8&scoped=true"
import script from "./ManufacturerSearch.vue?vue&type=script&lang=js"
export * from "./ManufacturerSearch.vue?vue&type=script&lang=js"
import style0 from "./ManufacturerSearch.vue?vue&type=style&index=0&id=552abeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552abeb8",
  null
  
)

export default component.exports